var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPipelineaggregate(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 8,
    viewBox: "0 0 11 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.899414 0V1.81818H3.77654L4.0163 0.681818L3.77654 0H0.899414Z",
    fill: "#FFDF40"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.2373 0H6.35419V1.81818H3.2373V0Z",
    fill: "#FFBE40"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0.899414 2.72705V4.54523H3.77654L4.0163 3.40887L3.77654 2.72705H0.899414Z",
    fill: "#FFDF40"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M0.899414 5.45459V7.27277H3.77654L4.0163 6.13641L3.77654 5.45459H0.899414Z",
    fill: "#FFDF40"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M3.2373 2.72705H6.35419V4.54523H3.2373V2.72705Z",
    fill: "#FFBE40"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M3.2373 5.45459H6.35419V7.27277H3.2373V5.45459Z",
    fill: "#FFBE40"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M4.89941 0.5V6.5H7.66864L7.89941 2.75L7.66864 0.5H4.89941Z",
    fill: "#40FFA3"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M6.89941 0.5H10.8994V6.5H6.89941V0.5Z",
    fill: "#1DBC70"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPipelineaggregate);
export default __webpack_public_path__ + "static/media/pipelineaggregate.31304e846fe17bd9e303ae921d5551f1.svg";
export { ForwardRef as ReactComponent };